export enum consentGroupIds {
  essentials = 'essentials',
  serviceMap = 'optionalServiceMap',
  matomo = 'optionalMatomo',
  askem = 'optionalAskem',
}
